import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const RAW_BASE_URL =
  process.env['NX_PUBLIC_API_BASE_URL'] || 'http://localhost:8080';
const BASE_URL = RAW_BASE_URL.endsWith('/')
  ? RAW_BASE_URL.slice(0, -1)
  : RAW_BASE_URL;

export interface LogQueryParams {
  query: string;
  start_time?: string;
  end_time?: string;
}

export interface LogEvent {
  id: string;
  timestamp: string;
  level?: string;
  message: string;
  job_id?: string;
  flow_job_id?: string;
  [key: string]: any;
}

export interface StatsRow {
  [key: string]: string;
}

export interface LogQueryMeta {
  count?: number;
  query_type?: 'stats';
  records_matched?: number;
  records_scanned?: number;
  warnings?: string[];
}

export interface LogQueryResponse {
  data: any[];
  meta: LogQueryMeta;
}

export const useLogQuery = (
  accountId: string | undefined,
  params: LogQueryParams,
  options?: { enabled?: boolean },
) => {
  return useQuery<LogQueryResponse>({
    queryKey: [
      'logs',
      accountId,
      params.query,
      params.start_time,
      params.end_time,
    ],

    queryFn: async () => {
      const response = await axios.get(
        `${BASE_URL}/accounts/${accountId}/logs`,
        {
          params: {
            query: params.query,
            ...(params.start_time && { start_time: params.start_time }),
            ...(params.end_time && { end_time: params.end_time }),
          },
          withCredentials: true,
          timeout: 120000,
        },
      );
      return response.data;
    },

    enabled: Boolean(accountId) && (options?.enabled ?? true),
    staleTime: 0,
    retry: false,
  });
};
